<template>
  <div :class="lang === 'en' ? 'en' : 'cn'">
    <div class="jc-page-header">
      <h1>
        <span>{{ $t('实例抵扣券列表') }}</span>
      </h1>
    </div>
    <div class="jc-page-content">
      <div class="jc-container-table">
        <div class="jc-container-table-actionBar">
          <jc-form
            class="jc-table-actionBar-item"
            style="width: 100%"
            :inline="true"
          >
            <jc-form-item :label="$t('类型：')">
              <jc-select v-model="form.voucherType">
                <jc-option
                  v-for="item in productLineList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></jc-option>
              </jc-select>
            </jc-form-item>
            <jc-form-item :label="$t('状态：')">
              <jc-select v-model="form.status">
                <jc-option
                  v-for="item in statusType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></jc-option>
              </jc-select>
            </jc-form-item>
            <jc-form-item :label="$t('创建时间：')">
              <jc-date-picker
                v-model="daterange"
                :editable="false"
                type="daterange"
                :placeholder="$t('选择日期范围')"
                clearable
              ></jc-date-picker>
            </jc-form-item>
            <jc-form-item>
              <jc-button type="primary" @click="search">{{
                $t('查询')
              }}</jc-button>
            </jc-form-item>
            <a href="javascript:void(0)" @click="exportList" class="export">{{
              $t('导出')
            }}</a>
          </jc-form>
        </div>
        <jc-table :data="tableData" class="loading-table">
          <jc-table-column prop="instanceVoucherId" :label="$t('实例抵扣券ID')">
            <template scope="scope">{{
              scope.row.instanceVoucherId | filterParams
            }}</template>
          </jc-table-column>
          <jc-table-column prop="instanceVoucherType" :label="$t('类型')">
            <template scope="scope">{{
              filterInstanceType(scope.row.instanceVoucherType)
            }}</template>
          </jc-table-column>
          <jc-table-column prop="isReserved" :label="$t('资源预留')">
            <template scope="scope">{{
              scope.row.isReserved | filterIsReserved
            }}</template>
          </jc-table-column>
          <jc-table-column prop="region" :label="$t('地域')">
            <template scope="scope">{{
              $t(scope.row.region) | filterParams
            }}</template>
          </jc-table-column>
          <jc-table-column
            prop="balanceAmount"
            :label="$t('规格/数量')"
            min-width="110px"
          >
            <template scope="scope">
              <div>
                <p>
                  {{ scope.row.tips | filterParams }}：{{
                    scope.row.label | filterParams
                  }}
                </p>
                <p>
                  {{ scope.row.unit | filterParams }}：{{
                    scope.row.count | filterParams
                  }}
                </p>
              </div>
            </template>
          </jc-table-column>
          <jc-table-column
            prop="createTime"
            :label="$t('创建时间')"
            min-width="120px"
          >
            <template scope="scope">{{
              scope.row.createTime | filterParams
            }}</template>
          </jc-table-column>
          <jc-table-column
            prop="startTime"
            :label="$t('生效时间')"
            min-width="120px"
          >
            <template scope="scope">{{
              scope.row.startTime | filterParams
            }}</template>
          </jc-table-column>
          <jc-table-column
            prop="endTime"
            :label="$t('失效时间')"
            min-width="120px"
          >
            <template scope="scope">{{
              scope.row.endTime | filterParams
            }}</template>
          </jc-table-column>
          <jc-table-column prop="status" :label="$t('状态')">
            <template scope="scope">{{
              scope.row.status | filterStatusEffective
            }}</template>
          </jc-table-column>
        </jc-table>
        <div class="jc-container-table-actionBar" v-if="totalCount > 0">
          <jc-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="form.pageNum"
            :page-sizes="[10, 20, 50]"
            :page-size="form.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          ></jc-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dicMixins from '@/mixins/dic-mixins'
import { getDate } from '@/utils'
import { statusType } from '@/utils/constant'
import { getResourceList, exportList } from '@/api/instances-api'
export default {
  name: 'list',
  props: [],
  components: {},
  mixins: [dicMixins],
  data() {
    return {
      form: {
        voucherType: '',
        status: 1,
        pageSize: 10,
        pageNum: 1,
        createTimeBegin: '',
        createTimeEnd: ''
      },
      daterange: [],
      statusType: statusType,
      tableData: [],
      totalCount: 0
    }
  },
  watch: {},
  computed: {},
  mounted() {},
  created() {
    this.getList()
  },
  filters: {},
  methods: {
    filterInstanceType(val) {
      let target = this.productLineListNoAll.find(ele => ele.value === val)
      return target ? target.label : '--'
    },
    // 分页更改
    handleSizeChange(val) {
      this.form.pageSize = val
      this.form.pageNum = 1
      this.getList()
    },
    // 分页更改
    handleCurrentChange(val) {
      this.form.pageNum = val
      this.getList()
    },
    search() {
      this.form.pageNum = 1
      this.getList()
    },
    handleTime() {
      if (this.daterange && this.daterange[0]) {
        this.form.createTimeBegin = getDate(this.daterange[0]).txt_ymdhms
        let temp = getDate(this.daterange[1]).txt_ymdhms
        this.form.createTimeEnd = temp.split(' ')[0] + ' 23:59:59'
      } else {
        this.form.createTimeBegin = ''
        this.form.createTimeEnd = ''
      }
    },
    // 获取列表
    async getList() {
      this.handleTime()
      const { result } = await getResourceList(this.form)
      this.tableData = result.data
      this.totalCount = result.pagination && result.pagination.numberRecords
    },
    async exportList() {
      this.handleTime()
      let reqData = Object.assign({}, this.form)
      delete reqData.pageSize
      delete reqData.pageNum
      const { result } = await exportList(reqData)

      let exportUrl
      if (!result.result) return
      exportUrl = result.result.replace(/^(http:|https:)/, '')

      window.open(exportUrl, '_blank')
    }
  }
}
</script>
<style scoped>
.jc-form--inline .jc-form-item {
  margin-right: 20px;
}
.jc-button {
  width: 70px;
}
.export {
  margin-left: 20px;
  float: right;
  line-height: 30px;
}
</style>
